import React, { useState, useEffect } from 'react'
import { Formik, Form, Field } from 'formik'
import FormikControl from '../../hoc/formikComponents/FormikControl'
import { useMutation, useQuery } from 'react-query'
import ToastInstance from '../../hoc/NotificationSettings/ToastInstance'
import Fetcher from '../../hoc/FetcherSetting/FetcherSetting'
import { useParams } from 'react-router'
import { useHistory } from "react-router-dom";
import { APIURL } from "../../hoc/AxiosSetting/axios.js";
import axios from "axios";
import  { MultiSelect } from "react-multi-select-component";
import { useQueryClient } from 'react-query'

function LeadAuditorForm() {
    const queryClient = useQueryClient();
    const { id } = useParams()
    const history = useHistory();
    const [subnacecodeList, setSubnacecodeList] = useState([{  
        label: "Select",
        value: ""
    }])
   
    const [initialValues, setInitialValues] = useState({
        _id: "",
        nacemaincode: "",
        nacemaincodeName: "",
        nacesubcode:[],
        designationName:"",
        processproductknow: "",
        terminologiesused: "",
        technologiesknown: "",
        othertypicalpractices: "",
        statutoryandregulatoryre: "",
        qualification: "",
        workingexperience: "",
        auditexperience: "",
        evaluationmethod: "",
        risklevel: "",
      
    })
    const designationNameList = [
        { key: 'Select', value: '-' },
        { key: " Auditor", value: " Auditor" },
        { key: " Technical Expert", value: " Technical Expert" }
    ]
    const { data: competancydataList, isLoading } = useQuery(
        'listcode',
        () => Fetcher('get', '/api/competancy/get/competancydata/' + id, {}))
    
    const { data: nacecodeList, isLoading: nacecodeListLoading } = useQuery(
        'listnacecode',
        () => Fetcher('get', '/api/nace/get/listmaincodewithkeylabel', {}))
    
    const mutationCompetancyDetails = useMutation((params) => Fetcher('get', '/api/nace/get/listsubcodewithkeylabel/' + params, {}), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                console.log("mutationCompetancyDetails",data.data.response)
                setSubnacecodeList(data.data.response)
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })   
    const mutation = useMutation((params) => Fetcher('post', '/api/competancy/post/data', params), {
            onSuccess(data) {
                console.log("data",data)
                if (data.data.errorCode === 0) {
                    ToastInstance('Success', 'Competancy Added')
                   // history.push("/"+localStorage.getItem("role")+ '/viewofleadauditorform/' + data.data.response._id);
    
                } else {
                    var msg = 'Competancy - ' + data.data.errorMsg;
                    ToastInstance('Error', msg)
                }
            },
            onError(error) {
                console.error('Got error from backend', error)
                ToastInstance('Error', 'Competancy' + error)
            }
    })
    const onSubmit = (values, { setSubmitting, resetForm }) => {
        console.log("value 87", values)
        if (values._id === "") {
            mutation.mutate(values)
        } else {
            console.log("value edit", values)
            mutationEdit.mutate(values)

        }
    }
    const mutationEdit = useMutation((params) => Fetcher('patch', '/api/competancy/patch/competancydata', params), {
        onSuccess(data) {

            if (data.data.errorCode === 0) {

                ToastInstance('Success', 'Data Updated')
                queryClient.invalidateQueries('listcode');
                history.push("/"+localStorage.getItem("role")+ '/viewofleadauditorform/' + id);

            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })

    useEffect((e) => {
        if (competancydataList && initialValues._id === "") {
            console.log("148 id",id)
            var tempData = competancydataList.data.response
            if (tempData.nacemaincode && tempData.nacemaincode !== "") {
                mutationCompetancyDetails.mutate(tempData.nacemaincode)
            }
            setInitialValues(tempData)
            
           // mutationCompetancyDetails.mutate(competancydataList.data.response.nacesubcodeName)
        }
       
    }, [id && !isLoading && initialValues._id === ""])

    const [tempData, setTempData] = useState([])
    if (nacecodeListLoading) return <h1>Loading</h1>
    return (
        <div>
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                onSubmit={onSubmit}
            >
                {formik => <Form>
                    <div className="content-wrapper">
                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="card-body" style={{ paddingLeft: "4%", paddingRight: "4%" }}>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <div className="formOuterDiv">
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='select' label='Designation' name="designationName" options={designationNameList} />
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl control="selectNACECode" name="nacemaincode" label="Nace Code(Main code)" options={nacecodeList.data.response} 
                                                            
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(`nacemaincode`, e.value)
                                                                    formik.setFieldValue(`nacemaincodeName`, e.label) 
                                                                    mutationCompetancyDetails.mutate(e.value)
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl control="selectNACECode" name="nacesubcode" label="Nace Code(Sub code)" options={subnacecodeList} isMultipe="true"
                                                                onChange={(e) => {
                                                                    console.log("Nace Code(Sub code)",e)
                                                                    setTempData(e)
                                                                    console.log("tempData ",tempData);
                                                                    formik.setFieldValue(`nacesubcode`, e)
                                                                    // formik.setFieldValue(`nacesubcodeName`, e.label)
                                                                }}
                                                            /> 
                                                        </div>
                                                        <div className="form1RowDiv mt-3">
                                                            <label>Process & Product  Knowledge</label>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-sm-11" style={{ marginLeft: "1%" }}>
                                                                <FormikControl control='ckEditor' type='text' label='Process & Product  Knowledge' name="processproductknow" />
                                                            </div>
                                                        </div>

                                                        <div className="form1RowDiv">
                                                            <label>Terminologies Used</label>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-sm-11" style={{ marginLeft: "1%" }}>
                                                                <FormikControl control='ckEditor' type='text' label='Terminologies Used' name="terminologiesused" />
                                                            </div>
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <label>Technologies Known</label>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-sm-11" style={{ marginLeft: "1%" }}>
                                                                <FormikControl control='ckEditor' type='text' label='Technologies Known' name="technologiesknown" />
                                                            </div>
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <label>Other typical Practices</label>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-sm-11" style={{ marginLeft: "1%" }}>
                                                                <FormikControl control='ckEditor' type='text' label='Other typical Practices' name="othertypicalpractices" />
                                                            </div>
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <label>Statutory & Regulatory Requirements</label>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-sm-11" style={{ marginLeft: "1%" }}>
                                                                <FormikControl control='ckEditor' type='text' label='Statutory & Regulatory Requirements' name="statutoryandregulatoryre" />
                                                            </div>
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <label>Qualification</label>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-sm-11" style={{ marginLeft: "1%" }}>
                                                                <FormikControl control='ckEditor' type='text' label='Qualification' name="qualification" />
                                                            </div>
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <label>Working Experience</label>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-sm-11" style={{ marginLeft: "1%" }}>
                                                                <FormikControl control='ckEditor' type='text' label='Working Experience' name="workingexperience" />
                                                            </div>
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <label>Audit Experience</label>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-sm-11" style={{ marginLeft: "1%" }}>
                                                                <FormikControl control='ckEditor' type='text' label='Audit Experience' name="auditexperience" />
                                                            </div>
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <label>Evaluation method</label>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-sm-11" style={{ marginLeft: "1%" }}>
                                                                <FormikControl control='ckEditor' type='text' label='Evaluation method' name="evaluationmethod" />
                                                            </div>
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <label>Risk level</label>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-sm-11" style={{ marginLeft: "1%" }}>
                                                                <FormikControl control='ckEditor' type='text' label='Risk level' name="risklevel" />
                                                            </div>
                                                        </div>


                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <div className="card-footer">
                            <div className="row">
                                <div className="col-sm-10"></div>
                                <div className="col-sm-2">
                                    <button type="submit" className="btn btn-primary float-right">Submit</button>
                                </div>

                            </div>
                        </div>
                    </div>

                </Form>
                }
            </Formik>
        </div>
    )
}
export default LeadAuditorForm